import {
  TealiumErrorCode,
  TealiumErrorContext,
} from '##/services/analytics/Tealium/TealiumErrorTypes';
import { setFreeviewUrl } from '##/utils';
import { sendErrorToTealium } from '../Error';
import { deepLinkSignIn } from './DeepLinkSignIn';
import { deepLinkShow } from './DeepLinkShow';

const GUIDED_SETUP = '35';

const parseQueryString = (
  queryParamString: string,
): Record<string, string | undefined> => {
  const queryParamMap: Record<string, string | undefined> = {};
  queryParamString.split('&').forEach((queryPair) => {
    const [key, val] = queryPair.split(/=(.+)/);
    if (key) {
      queryParamMap[key] = decodeURIComponent(val);
    }
  });
  return queryParamMap;
};

export const deeplinkIfAvailable = (): void => {
  const queryParams = window.location.search.slice(1);
  if (!queryParams) return;

  try {
    const queryParamData = parseQueryString(queryParams);
    const { source_type: sourceType } = queryParamData;
    if (sourceType === GUIDED_SETUP) {
      // guided setup mode for login
      // used on IQ and Magneto
      deepLinkSignIn();
      return;
    }

    setFreeviewUrl(queryParamData?.['freeview-url']);

    const { episode, series } = queryParamData || {};

    if (!series || !episode) {
      return;
    }

    deepLinkShow({
      seriesCrid: series,
      episodeCrid: episode,
    });
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.DLShow,
      errorContext: TealiumErrorContext.DEEPLINK,
      errorDetail: JSON.stringify(err),
      errorSource: window.location.search,
      errorMessage: '',
    });
    // silently continue on to home page if unable to parse deeplink url
  }
};
